import React from "react";
import "./footer-tabs-rates.scss";
import Button from "../../atoms/button/button";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import GlobalContext from "../../../contexts/globalContext";
import { navigate } from "gatsby";

export interface PropsTabsRates {
  tabsSectionRatesData: any;
  activeItem: number;
}
const FooterRatesTabs = (props: PropsTabsRates) => {
  const activeItem = props.activeItem;
  const refContenido = props.tabsSectionRatesData.referenciaTabsContenido;

  const raw = JSON.parse(
    refContenido?.[activeItem]?.referenciaTarifas?.descripcion?.raw
  );

  return (
    <GlobalContext.Consumer>
      {() => (
        <div>
          <div className="m-tabs-sec__details-footer">
            <div className="m-tabs-sec__details-footer-phrase">
              <div
                className={`m-tabs-sec__details-footer-phrase-internal ${
                  refContenido[activeItem].referenciaTarifas.tituloDescripcion
                    ? "margin-rates"
                    : ""
                }`}
              >
                <div className="blockquoteopen"></div>
                <h4>
                  {
                    refContenido[
                      activeItem
                    ].referenciaTarifas.tituloBanner.split("(")[0]
                  }
                </h4>
                <p>
                  {refContenido[activeItem].referenciaTarifas.tituloBanner
                    .split("(")[1]
                    .slice(
                      0,
                      refContenido[
                        activeItem
                      ]?.referenciaTarifas?.tituloBanner?.split("(")[1]
                        ?.length - 1
                    )}
                </p>

                <div className="blockquoteclose"></div>
              </div>
              <div className="m-tabs-sec__details-footer-phrase-button">
                {/*
                <Button
                  text={refContenido[activeItem].referenciaTarifas.tituloBoton}
                  classname={`secondary button-large gtmRedDeAmor${normalizeTwoWords(
                    refContenido[activeItem].nombreTab
                  )}Tarifas${normalizeTwoWords(
                    refContenido[activeItem].referenciaTarifas.tituloBoton
                  )}`}
                  type="button"
                  isDisabled={false}
                  strictCss={false}
                  onClickAction={() => {
                    data.gigyaContext.gigyaAccount
                      ? navigate(
                          refContenido[activeItem].nombreTab !==
                            "Hábitos de salud mental"
                            ? "/agenda-red-de-amor"
                            : "/servicios/habitos-salud/"
                        )
                      : data.gigyaContext.login();
                  }}
                />
                */}
              </div>
            </div>
            <div
              className={`m-tabs-sec__details-footer-rates ${
                refContenido[activeItem].referenciaTarifas.tituloDescripcion
                  ? "rates-text"
                  : ""
              }`}
            >
              <h4
                className={`${
                  refContenido[activeItem].referenciaTarifas.tituloDescripcion
                    ? "titulo_rates"
                    : ""
                }`}
              >
                {refContenido[activeItem].referenciaTarifas.tituloDescripcion
                  ? refContenido[activeItem].referenciaTarifas.tituloDescripcion
                  : refContenido[activeItem].referenciaTarifas.descripcion &&
                    raw.content[0]?.content[0]?.value}
              </h4>
              <div
                className={`m-tabs-sec__details-footer-rates-organization ${
                  refContenido[activeItem].referenciaTarifas.tituloDescripcion
                    ? "organization-text"
                    : ""
                }`}
              >
                {refContenido[activeItem].referenciaTarifas.tituloDescripcion &&
                normalizeTwoWords(
                  refContenido[activeItem].nombreTab.split(" ")[0]
                ).toLowerCase() != "asesoría" ? (
                  <div>
                    <p className="secondary-rates">
                      {refContenido[activeItem].referenciaTarifas.descripcion &&
                        JSON.parse(
                          refContenido[activeItem].referenciaTarifas.descripcion
                            .raw
                        ).content[0]?.content[0]?.value}
                    </p>
                    <Button
                      text={
                        refContenido[activeItem].referenciaTarifas.tituloBoton
                      }
                      classname={`terciary button-large gtmRedDeAmor${normalizeTwoWords(
                        refContenido[activeItem].nombreTab
                      )}Tarifas${normalizeTwoWords(
                        refContenido[activeItem].referenciaTarifas.tituloBoton
                      )}`}
                      type="button"
                      isDisabled={false}
                      strictCss={false}
                      gtmMark={""}
                      onClickAction={() => {
                        navigate("/servicios/habitos-salud");
                      }}
                    />
                  </div>
                ) : normalizeTwoWords(
                    refContenido[activeItem].nombreTab.split(" ")[0]
                  ).toLowerCase() === "asesoría" ? (
                  <p className="secondary-rates">
                    {raw?.content[1]?.content[0]?.value}
                  </p>
                ) : (
                  refContenido[activeItem].referenciaTarifas.descripcion &&
                  raw.content[1]?.content?.map((val, key) => {
                    return (
                      <div
                        className="m-tabs-sec-int__details-footer-rates-bigcard"
                        key={key}
                      >
                        <div className="m-tabs-sec__details-footer-rates-minicard">
                          <p>
                            <span>
                              {val.content[0]?.content[0]?.value
                                ? val.content[0]?.content[0]?.value
                                : ""}
                            </span>
                            <strong>
                              {val.content[0]?.content[1]?.value
                                ? val.content[0]?.content[1]?.value
                                : ""}
                            </strong>
                            {val.content[0]?.content[2]?.value
                              ? val.content[0]?.content[2]?.value
                              : ""}
                          </p>
                        </div>
                        <p className="m-tabs-sec__details-footer-rates-minicard-subtitle">
                          {val.content[0]?.content[3]
                            ? val.content[0]?.content[3]?.value
                            : ""}
                        </p>
                      </div>
                    );
                  })
                )}
                {refContenido[activeItem].referenciaTarifas
                  .tituloDescripcion ? (
                  ""
                ) : (
                  <div className="free-rate">
                    <p className="free-rate-text">
                      {refContenido[activeItem].referenciaTarifas.descripcion &&
                      raw.content[2]?.content[0]?.value != ""
                        ? raw.content[2]?.content[0]?.value
                        : ""}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </GlobalContext.Consumer>
  );
};
export default FooterRatesTabs;
